import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { WeekSelectorProps } from "models/propTypes/timeReportingPropTypes";
import { DialogEnums } from "models/enums";
//#endregion
//#region components
import { ExtendedEntityPagination } from "components/common";
import WeekDateRange from "./_partial/weekDateRange";
import PeriodToggle from "../common/periodToggle";
import usePeriodSwitch from "../common/usePeriodSwitch";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";

const WeekSelector: React.FC<WeekSelectorProps> = (props) => {
  const { currentWeekDateRange, onWeekToggle, hasUnSavedChanges, onCreateOrUpdateWeek, employeeId } = props;

  const { showMonth } = usePeriodSwitch();

  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const onNextWeekClick = () => {
    const newLoadingDate = currentWeekDateRange?.start && DateHelper.addDays(currentWeekDateRange?.start, 7);
    newLoadingDate && onWeekOrMonthToggle(onWeekToggle.bind(null, newLoadingDate));
  };

  const onPreviousWeekClick = () => {
    const newLoadingDate = currentWeekDateRange?.start && DateHelper.addDays(currentWeekDateRange?.start, -7);
    newLoadingDate && onWeekOrMonthToggle(onWeekToggle.bind(null, newLoadingDate));
  };

  const onSaveChangesAndNavigate = (submitFunc: () => void) => {
    return (
      onCreateOrUpdateWeek &&
      onCreateOrUpdateWeek().then((res) => {
        submitFunc();
      })
    );
  };

  const onWeekOrMonthToggle = (submitFunc: () => void) => {
    if (hasUnSavedChanges) {
      dispatch(
        displayDialog({
          isOpen: false,
          title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.UnSavedChanges),
          titleIcon: IconDefinitionConstants.WQuestionCircle,
          dialogType: DialogEnums.DialogType.Message,
          actions: [
            {
              text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.DontSave),
              onClick: async () => await submitFunc(),
            },
            {
              text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Save),
              onClick: async () => await onSaveChangesAndNavigate(submitFunc),
            },
          ],
          children: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.TimeReporting.SaveChangesBeforeSubmit
          ),
        })
      );
    } else {
      submitFunc();
    }
  };

  const onShowMonthClick = () => {
    onWeekOrMonthToggle(onShowMonth);
  };

  const onShowMonth = () => {
    showMonth(currentWeekDateRange?.start ?? new Date(), employeeId);
  };

  return (
    <ExtendedEntityPagination
      textNext={TranslationKeys.TimeReporting.NextWeek}
      textPrevious={TranslationKeys.TimeReporting.PreviousWeek}
      onNavigationNext={onNextWeekClick}
      onNavigationPrevious={onPreviousWeekClick}
      actions={<PeriodToggle period="week" onShowMonth={onShowMonthClick} />}
    >
      {currentWeekDateRange && (
        <WeekDateRange
          start={currentWeekDateRange.start ?? new Date()}
          end={currentWeekDateRange.end ?? new Date()}
        ></WeekDateRange>
      )}
    </ExtendedEntityPagination>
  );
};

export default WeekSelector;
